import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { BRAND } from "../data/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-stone-900 text-stone-100"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-28 pb-16">
        {/* Large CTA */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-20 border-b border-stone-700/60">
          <div className="lg:col-span-8">
            <p className="uppercase text-xs tracking-[0.25em] text-stone-400 mb-6">
              Let's talk
            </p>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-7xl leading-[1.05] tracking-tight">
              Planning a remodel in
              <span className="block text-[#C77F4B] italic font-light">
                Oregon or Washington?
              </span>
            </h2>
            <p className="text-stone-400 text-base sm:text-lg mt-8 max-w-xl leading-relaxed">
              Call us to walk through your project. No pressure, no obligation — just
              straight answers from a licensed builder with {BRAND.yearsInBusiness} years on the tools.
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col justify-end gap-4">
            <a
              href={BRAND.phoneLink}
              data-testid="footer-phone-cta"
              className="group flex items-center justify-between bg-[#9B4819] hover:bg-[#7A3813] text-white px-6 py-5 transition-all duration-300"
            >
              <span className="flex items-center gap-3">
                <Phone className="w-5 h-5" strokeWidth={2.25} />
                <span className="text-lg font-medium tracking-wide">
                  {BRAND.phoneDisplay}
                </span>
              </span>
              <ArrowUpRight className="w-5 h-5 group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href={BRAND.emailLink}
              data-testid="footer-email-cta"
              className="group flex items-center justify-between border border-stone-600 hover:border-stone-300 text-stone-100 px-6 py-5 transition-all duration-300"
            >
              <span className="flex items-center gap-3">
                <Mail className="w-5 h-5" />
                <span className="text-sm tracking-wide">Email us</span>
              </span>
              <ArrowUpRight className="w-5 h-5 group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>

        {/* Secondary footer */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pt-16">
          <div className="md:col-span-5">
            <div className="font-display text-sm tracking-[0.25em] text-stone-200">
              MORGAN CONSTRUCTION GROUP
            </div>
            <p className="text-stone-400 text-sm mt-4 leading-relaxed max-w-sm">
              {BRAND.tagline} Licensed & insured residential remodeling in
              Oregon and Washington.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="uppercase text-xs tracking-[0.2em] text-stone-500 mb-4">
              Navigate
            </div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-stone-300 hover:text-white">Home</Link></li>
              <li><Link to="/services" className="text-stone-300 hover:text-white">Services</Link></li>
              <li><Link to="/gallery" className="text-stone-300 hover:text-white">Gallery</Link></li>
              <li><Link to="/about" className="text-stone-300 hover:text-white">About</Link></li>
              <li><Link to="/contact" className="text-stone-300 hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="uppercase text-xs tracking-[0.2em] text-stone-500 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-stone-300">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#C77F4B]" />
                <a href={BRAND.phoneLink} className="hover:text-white">
                  {BRAND.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#C77F4B]" />
                <a href={BRAND.emailLink} className="hover:text-white">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#C77F4B]" />
                <span>Serving {BRAND.serviceArea}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-14 mt-14 border-t border-stone-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-stone-500 tracking-wide">
          <p>© {new Date().getFullYear()} {BRAND.legalName}. All rights reserved.</p>
          <p>Licensed · Bonded · Insured · CCB #{BRAND.ccbLicense}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
